import moment from 'moment';

// Email validation
export function validateEmail(email) {
  /* eslint-disable */
  const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regex.test(email);
}

export function formatErrors(errors) {
  return errors.map(({ message }) => message);
}

export function timeElapsed(datetime) {
  const formattedDate = date => new Date(date).toLocaleDateString();

  return moment(formattedDate(datetime), 'MM/DD/YYYY').fromNow();
}

// Format total of users/answers/questions
export function formatTotals(total) {
  let formattedTotal;
  const thousand = 1000;
  const million = 1000000;

  if (total < thousand) {
    formattedTotal = total;
  } else if (total >= thousand && total < million) {
    formattedTotal = `${(total / thousand).toFixed(1)}k`;
  } else {
    formattedTotal = `${(total / million).toFixed(1)}m`;
  }

  return formattedTotal;
}
